import fundaNowClient from '@/client/fundaNowClient'
import AuthService from '@/service/auth/AuthService'

export default {
  getTerms() {
    return fundaNowClient.call({
      url: '/contracts/terms/',
      method: 'GET',
    })
  },
  getTerm(code) {
    return fundaNowClient.call({
      url: '/contracts/terms/code',
      method: 'GET',
      params: {
        code: code
      }
    })
  },
  agreeTerm(id, data) {
    return fundaNowClient.call({
      url: `/contracts/terms/${id}/agree/`,
      method: 'POST'
    })
  },
  disagreeTerm(id) {
    return fundaNowClient.call({
      url: `/contracts/terms/${id}/disagree/`,
      method: 'POST'
    })
  },
  getAgreements() {
    return fundaNowClient.call({
      url: '/contracts/agreements/',
      method: 'GET'
    })
  },
  getAgreementByOffer(offer) {
    return fundaNowClient.call({
      url: '/contracts/agreements/offer',
      method: 'GET',
      params: {
        offer: offer
      }
    })
  },
  getAgreementByTerm(term) {
    return fundaNowClient.call({
      url: '/contracts/agreements/term',
      method: 'GET',
      params: {
        term: term
      }
    })
  },
  postAgreement(data) {
    return fundaNowClient.call({
      url: '/contracts/agreements/',
      method: 'POST',
      data: data
    })
  },
  getDocuments() {
    if (!AuthService.getProfile()) { return }
    return fundaNowClient.call({
      url: `/documents/${AuthService.getProfile().uuid}/`,
      method: 'GET'
    })
  },
  patchDocuments(data) {
    if (!AuthService.getProfile()) { return }
    return fundaNowClient.call({
      url: `/documents/${AuthService.getProfile().uuid}/`,
      method: 'PATCH',
      data: data
    })
  },
  getCurrentContract() {
    return fundaNowClient.call({
      url: '/contracts/current/',
      method: 'GET'
    })
  },
  getFundaman(code) {
    return fundaNowClient.call({
      url: `/agents/${code}/`,
      method: 'GET'
    })
  },
  postAssignFundaman(code) {
    return fundaNowClient.call({
      url: `/agents/${code}/assign/`,
      method: 'POST'
    })
  },
  postAgreementsAgree(termId, data) {
    return fundaNowClient.call({
      url: `/contracts/terms/${termId}/agree/`,
      method: 'POST',
      data: data
    })
  }
}
